import * as ex from 'excalibur';
import { PlayerUnit } from './playerUnit';

// Player-controlled Rogue
export class PlayerRogue extends PlayerUnit {
  constructor(options: any) {
    super({
      gridX: options.gridX,
      gridY: options.gridY,
      type: 'rogue',
      name: 'Rogue',
      color: ex.Color.Yellow,
      initiative: options.initiative,
      health: 25,
      maxHealth: 25,
      moveRange: 1,
      attackRange: 1,
      abilities: ['backstab', 'diagonal_move'],
      grid: options.grid
    });

    // Set the emoji for this unit type
    this.setEmoji("🗡️"); // Dagger for rogue/sneaky type
  }
}